setAssetsList